import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";
import { Getdocumenttypes } from "../../../store/documenttype-store/documenttype-actions";
import { documenttypeActions } from "../../../store/documenttype-store/documenttype-slice";


const DocumenttypesHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const documenttype = useSelector((state) => state.documenttype);


  useEffect(() => {
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("documentType.showAll")) {
      dispatch(Getdocumenttypes(userInfo.Email, true));
    }else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("documentType.menu")
    ) {
      window.location.href = "/home";
    }

  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const viewDetailHanlder = (val) => {
    navigate(`/documenttype/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/documenttype/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      documenttypeActions.setDocumenttype({
        documenttype: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/documenttype/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("documentType.edit")) {
      buttons.push(buttonEdit);
    }
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("documentType.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "118vh"}}>
    <ABADatatable
      width="20%"
      title="Tipo de documento"
      values={documenttype.documenttypes}
      rows={5}
      rowsPerPageOptions={[5, 10, 20]}
      Columns={columns}
      actions={actions}
      createButton={{
        label: "Agregar",
        onClick: createHanlder,
        permission: "documentType.create",
      }}
      backButton={{
        label: "Regresar",
        onClick: backHanlder,
        permission: "goBack",
      }}
    />
    </div>
  </>
  );
};
export default DocumenttypesHomePage;
